import { jsx } from 'react/jsx-runtime';
import cx from 'clsx';
import { s as styleInject } from './style-inject.es-tgCJW-Cu.js';

var css_248z = ".SGCM_UIKIT_REACT_ErrorMessage_textRoot_1qb3a_1 {\n  color: #db1a21;\n  font-size: 1.4rem;\n  grid-area: errorMessage;\n  line-height: 1.286;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGNBQWM7RUFDZCxpQkFBaUI7RUFDakIsdUJBQXVCO0VBQ3ZCLGtCQUFrQjtBQUNwQiIsImZpbGUiOiJzdHlsZXMubW9kdWxlLnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIudGV4dFJvb3Qge1xuICBjb2xvcjogI2RiMWEyMTtcbiAgZm9udC1zaXplOiAxLjRyZW07XG4gIGdyaWQtYXJlYTogZXJyb3JNZXNzYWdlO1xuICBsaW5lLWhlaWdodDogMS4yODY7XG59Il19 */";
var styles = {"textRoot":"SGCM_UIKIT_REACT_ErrorMessage_textRoot_1qb3a_1"};
styleInject(css_248z);

const ErrorMessage = ({ children, className, }) => (jsx("span", { className: cx(styles.textRoot, className), children: children }));

export { ErrorMessage as E };
//# sourceMappingURL=component-DpLq47dX.js.map
